import * as React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import ERoute from '../../ERoute'
import EventTypes from './EventTypes'
import EventTypeEditor from './EventType'
import Bookings from './Bookings'

export default function Scheduling() {
  return (
    <Switch>
      <Route path={ERoute.PATH_SCHEDULING_EVENT_TYPE} component={EventTypeEditor} />
      <Route path={ERoute.PATH_SCHEDULING_EVENT_TYPES} component={EventTypes} />
      <Route path={ERoute.PATH_SCHEDULING_BOOKINGS} component={Bookings} />
      <Redirect to={ERoute.PATH_SCHEDULING_EVENT_TYPES} />
    </Switch>
  )
}
